import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Alert from '@material-ui/lab/Alert';
import Image from './asset.png';
const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: '100%',
    marginBottom: theme.spacing(5)
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0
  },
  textField: {
    minWidth: '62%'
  },
  checkButton: {
    marginLeft: '2%',
    float: 'right'
  },
  image: {
    height: '150px',
    marginRight: '2%'
  },
  submitButton: {
    minWidth: '100%',
  },
  loading: {
    border: '10px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '10px solid #3498db',
    width: '100px',
    height: '100px',
    animation: '$spin 2s linear infinite'
  },
  '@-webkit-keyframes spin': {
    '0%': {
        webkitTransform: 'rotate(0deg)'
    },
    '100%': {
        webkitTransform: 'rotate(360deg)'
    }
  },
  '@keyframes spin': {
      '0%': {
          transform: 'rotate(0deg)'
      },
      '100%': {
          transform: 'rotate(360deg)'
      }
  },
  alert: {
    marginTop: '1rem'
  }
}));
export default function Loan(props) {
  const CurrentDate = new Date();
  const CurrentYear = CurrentDate.getFullYear();
  const [ReturnYear, setReturnYear] = useState(CurrentYear);
  const classes = useStyles();
  const [assetNo, setAssetNo] = useState('');
  const [returnDate, setReturnDate] = useState((CurrentYear + 1) + "-07-31");
  const [studentNumber, setStudentNumber] = useState();
  const [loanYear, setLoanYear] = useState("1");
  const [error, setError] = useState(false);
  const [assetInfo, setAssetInfo] = useState([]);
  const [alert, setAlert] = useState();
  const [loading, setLoading] = useState();
  useEffect(() => {
    if(CurrentDate.getMonth() >= 7)
    {
      setReturnYear(CurrentYear + 1)
    }
    
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
      fetch("https://lapsafeapi.azurewebsites.net/api/laptoploans?HornbillKey=SHlm6QIeUab87XZG00iF&Permission=" + props.props.account.idToken.roles[0], requestOptions).then(response => response.json()).then((data) => {
        setAssetInfo(data);
    });
  },[props.props.account.idToken.roles, CurrentYear]);
  const handleDropDownChange = (event) => {
    var ReturnYear = CurrentYear;
    switch(event.target.name)
    {
      case "ddlLoanTerm":
        switch(event.target.value)
        {
          case "1": 
            ReturnYear = ReturnYear + 1;
            setReturnDate(ReturnYear + "-07-31");
            break;
          case "2":
            ReturnYear = ReturnYear + 2;
            setReturnDate(ReturnYear + "-07-31");
            break;
          default:
        }
        setLoanYear(event.target.value);
        break;
      default:
    }
  };
  const handleTextChange = (event, value) => {
    switch(event.target.id)
    {
      case "studentNumber":
        setStudentNumber(event.target.value);
        break;
      default:
        setAssetNo(value.HornbillAssetId);
    }
  };
  const SubmitLoan = () => {
    setError(false);
    setAlert();
    if(studentNumber.length !== 6)
    {
      setError(true);
      setAlert(<Alert severity="error">You haven't entered a correct student number.</Alert>);
      return;
    }
    var Data = {
      assetid: assetNo,
      returndate: returnDate,
      studentno: studentNumber,
      staffname: props.props.account.userName
    };
    setLoading(<Container className={classes.loading}></Container>);
    var requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Data)
    };
    fetch("https://lapsafeapi.azurewebsites.net/api/laptoploans?HornbillKey=SHlm6QIeUab87XZG00iF", requestOptions).then(response => response.json()).then((data) => {
      setLoading();
      if(data.Message === "Device has now been updated as loaned out unit the date specified")
      {
        setAlert(<Alert severity="success">{data.Message}</Alert>);
        requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        };
          fetch("https://lapsafeapi.azurewebsites.net/api/laptoploans?HornbillKey=SHlm6QIeUab87XZG00iF&SearchText=", requestOptions).then(response => response.json()).then((data) => {
            setAssetInfo(data);
        });
      }
      else if(data.ExceptionMessage === "The specified user does not exist")
      {
        setAlert(<Alert severity="error">The student number doesn't exist in our system. Please try again or log a job: <a href="https://service.hornbill.com/derbycollege">Click Here</a></Alert>);
      }
    });
  };
  return (
      <Container className={classes.container}>
        <FormControl className={classes.formControl}>
        <InputLabel id="ddlLoanTermlbl">Loan Term - Please select 1 Year if the students course is due to finish on or before 01/08/{ReturnYear}</InputLabel>
          <Select labelId="ddlLoanTermlbl" name="ddlLoanTerm" value={loanYear} onChange={handleDropDownChange} label="Loan Term">
            <MenuItem key={1} value="1">1 Year</MenuItem>
            <MenuItem key={2} value="2">2 Year</MenuItem>
          </Select>
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField variant="outlined" name="studentNumber" error={error} label="Student Number" id="studentNumber" className={classes.formElement} onChange={handleTextChange} />
        </FormControl>
        <Typography>Please enter the asset number which is a sticker on the bottom of the laptop, it looks like the image here:</Typography>
        <Container className={classes.textContainer}>
          <img src={Image} alt="Derby College Asset Tag" className={classes.image}></img>
          <Autocomplete id="AssetNo" onChange={handleTextChange} options={assetInfo} getOptionLabel={(option) => option.DCAsset} style={{ width: 300 }} renderInput={(params)  => <TextField {...params} label="Asset No" variant="outlined" />}/>
        </Container>
        <Button variant="contained" color="primary" className={classes.SubmitButton} onClick={SubmitLoan}>Loan Out Device</Button>
        {loading}
        {alert}
      </Container>
  );
}